export default {"src":"/_next/static/media/reward.7624f048.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};